import * as changePassword from './changePassword';
import * as changeCancel from './changeCancelButton';
import { post } from '../Services/http';

const VanillaComponents = () => {
    const idPassword = 'js-change-password-btn';
    if (document.getElementById(idPassword)) {
        changePassword.changePasswordButton(idPassword);
    }

    const idCancel = 'js-cancel-change-password-btn';
    if (document.getElementById(idCancel)) {
        changeCancel.changeCancelButton(idCancel);
    }

    if (window?.__litium?.preloadState?.myPage?.isBusinessCustomer) {
        // Log out the user after 1 hour of inactivity.
        var oneHourAndOneSecond = 1000 * 60 * 60 + 1000;
        function checkLoginStatus() {
            post('/api/authenticate')
                .catch((ex) => location.reload());
        }

        var checkLoginStatusTimer = setInterval(checkLoginStatus, oneHourAndOneSecond);

        addEventListener('click', (event) => {
            clearInterval(checkLoginStatusTimer);
            checkLoginStatusTimer = setInterval(checkLoginStatus, oneHourAndOneSecond);
        });
    }
};

export default VanillaComponents